import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { IlloPercentCircle } from "../../atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "./BenefitEnrollmentFlowModal"
import { Steps } from "./Workflow/Steps"
import { useProgressTracker } from "../ProgressTracker"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.INFORMATIONAL

const InformationalTellUsInsuranceView: FC = () => {
  const { setNextStep } = useStateMachine(ViewName, null)

  const { hideProgress } = useProgressTracker()
  hideProgress()

  return (
    <div>
      <FlexRowCenter>
        <IlloPercentCircle />
      </FlexRowCenter>
      <Spacer height={1} />
      <H2 variant="dark">{l`In order to reimburse you, we need some info about your health insurance.`}</H2>
      <Spacer height={0.5} />

      <Body color="black-80">{l`We're asking these questions because your insurance coverage affects how your Carrot 
      benefit is taxed and if a deductible applies.`}</Body>
      <Spacer height={1} />
      <Body color="black-80">{l`If we determine you have a deductible, it needs to be met before we can reimburse you 
      for qualified medical expenses. Once it's met, you'll get tax-free reimbursement for those expenses. If we 
      determine you don't have a deductible, we can start reimbursing you right away.`}</Body>
      <Spacer height={1} />
      <Body color="black-80">{l`You may want to have your insurance card nearby, as well as insurance info for your 
      partner, if you have one. `}</Body>
      <Spacer height={2} />
      <BenefitEnrollmentModalContinueButton onClick={() => setNextStep(ViewName, "")} />
    </div>
  )
}

export { InformationalTellUsInsuranceView }
